import { useEffect } from 'react'
import fontsMetadata from '../../fonts_metadata.json'
import FontFaceObserver from 'fontfaceobserver'

export const FontLoader = ({ fontDataArr, onStatusChanged }) => {
    const createFontURL = (font, weight) => {
        return `https://fonts.googleapis.com/css?family=${font}:${weight}&subset=latin`
    }

    const _hasFont = (font) => {
        return font in fontsMetadata
    }

    const _hasWeight = (font, weight) => {
        return fontsMetadata[font].includes(weight.toString())
    }

    useEffect(() => {
        if (fontDataArr.length == 0) {
            return
        }

        let ffoPromises = fontDataArr.map(({ font, weight }) => {
            if ((!font) in fontsMetadata) {
                console.log('FONT NOT AVAILABLE', font)
            }

            let targetWeight = weight
            if (!_hasWeight(font, weight)) {
                // Fallback to smallest size
                let fallbackWeight = fontsMetadata[font][0]
                console.log(
                    `desired weight ${weight} for font ${font} does not exist, falling back to ${fallbackWeight}`
                )
                targetWeight = fallbackWeight
            }

            console.log(`loading ${font} ${targetWeight}`)
            let ffo = new FontFaceObserver(font, {
                weight: targetWeight,
            })
            return ffo
                .load()
                .then(() => {
                    console.log(
                        `Font ${font} ${targetWeight} was loaded correctly`
                    )
                })
                .catch((e) => {
                    console.log(
                        `Font ${font} ${targetWeight} failed to load ${e}`
                    )
                })
        })

        Promise.all(ffoPromises)
            .then(() => {
                console.log('All fonts loaded successfully')
            })
            .catch((e) => {
                console.log(
                    'WARNING: ALL FONTS WERE NOT LOADED SUCCESSFULLY. RENDERED IMAGE MAY BE INCORRECT',
                    e
                )
            })
            .finally(() => {
                onStatusChanged()
            })
    }, [fontDataArr])

    let fontUrls = fontDataArr.map(({ font, weight }) => {
        if (!_hasFont(font)) {
            console.log(
                `${font} NOT AVAILABLE, EXPECT WEIRD BEHAVIOR!!!!!!!!!!`,
                font
            )
        }

        let targetWeight = weight
        if (!_hasWeight(font, weight)) {
            // Fallback to smallest size
            let fallbackWeight = fontsMetadata[font][0]
            targetWeight = fallbackWeight
        }
        return createFontURL(font, targetWeight)
    })

    return (
        <>
            {fontUrls.map((url, idx) => (
                <link key={idx} rel="stylesheet" href={url} media="all" />
            ))}
        </>
    )
}
